export function applyCategoryMeta(category, route) {
    route.meta ??= {};
    route.meta.category = category;
    return route;
}
//# sourceMappingURL=applyCategoryMeta.js.map